import { AddCircleOutline, InsertChartOutlined } from '@material-ui/icons';
import { Button, Menu, withStyles } from "@material-ui/core";
import appConstants, { EVENT_TYPES, SESSION_STORAGE_KEYS, USER_ROLE } from '../../../../appConstants';

import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { PRO_MODE } from "../../../modules/Common/AddProToPlan/constants";
import React from 'react';
import RepeatIcon from '@material-ui/icons/Repeat';
import { compose } from 'recompose';
import { useNavigate } from "react-router-dom"
import { withUserProfile } from '../../../../userProfile/userProfileContext';
import Events from '../../../../utilities/EventEmitter';

const styles = (theme) => ({
  shipmentSelectionMenu: {
    background: theme.ModalBGColor,
    borderRadius: "0px 0px 4px 4px",
    marginTop: "4px",
  },
  shipmentSelectionMenuItem: {
    display: "flex",
    flexDirection: "column",
  },
  shipmentSelectionActionButton: {
    fontSize: "14px",
    color: theme.gridTextColor,
    justifyContent : "flex-start",
    alignItems : "center",
    padding : 8,
    "&:hover": {
      background: theme.customMultiSelectColor,
    },
    '&$disabledButton': {
      cursor: "not-allowed",
      pointerEvents: "all",
      color: theme.disabledColor,
      opacity: 0.7,
    }
  },
  disabledButton: {},
  menuLabel : {
    marginLeft : 8
  }
});

const ShipmentSelectionMenu = ({
  open,
  menuAnchor,
  onClose,
  openSettings,
  classes,
  openAddUpdateProToPlan,
  isDefaultScenario,
  userData,
  configJSON
}) => {
  const navigate = useNavigate();
  const goToScenarioExplorer = (e) => {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.ACTIVE_SETTINGS_MODULE, appConstants.SETTINGS_MODULES.SCENARIO_EXPLORER);
    openSettings(e, "/settings");

    // This event helps when switching to scenario explorer from other settings modules
    Events.emit(EVENT_TYPES.SETTINGS.MODULE_CHANGE, appConstants.SETTINGS_MODULES.SCENARIO_EXPLORER);
    onClose();
  };

  const goToShipmentForecast = (e) => {
    navigate(appConstants.NAV_URLS.SHIPMENT_FORECAST);
  }

  const hasAdminOrManagerAccess = () => {
    const { isAdmin, roles } = userData?.userProfile || {};
    return isAdmin || roles.includes(USER_ROLE.MANAGER);
  };

  const addPlan = () => {
    navigate(appConstants.NAV_URLS.SHIPMENT_SELECTION);
  };

  const updatePlan = () => {
    navigate(appConstants.NAV_URLS.SHIPMENT_SELECTION, {
      state: { action: "updateCurrentPlan" },
    });
  };

  const onAddUpdateProToPlanClick = (value) => {
    openAddUpdateProToPlan(value);
    onClose();
  };

  return (
    <Menu
      disablePortal={true}
      getContentAnchorEl={null}
      disableAutoFocusItem={true}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      anchorEl={menuAnchor}
      onClose={onClose}
      MenuListProps={{ disablePadding: true }}
      classes={{
        paper: classes.shipmentSelectionMenu,
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <div className={classes.shipmentSelectionMenuItem}>
        <Button
          classes={{
            root: classes.shipmentSelectionActionButton,
            disabled: classes.disabledButton
          }}
          onClick={addPlan}
        >
          <AddIcon /> <span className={classes.menuLabel}>Add a New Plan</span>
        </Button>
        <Button
          classes={{
            root: classes.shipmentSelectionActionButton,
            disabled: classes.disabledButton
          }}
          onClick={updatePlan}
        >
          <EditIcon />
          <span className={classes.menuLabel}>Update Current Plan</span>
        </Button>
        <Button
          classes={{
            root: classes.shipmentSelectionActionButton,
            disabled: classes.disabledButton
          }}
          onClick={goToScenarioExplorer}
        >
          <RepeatIcon /> <span className={classes.menuLabel}>Switch Plan</span>
        </Button>
        <Button
          classes={{
            root: classes.shipmentSelectionActionButton,
            disabled: classes.disabledButton
          }}
          disabled={!isDefaultScenario}
          onClick={() => {
            isDefaultScenario ? onAddUpdateProToPlanClick(PRO_MODE.add) : null;
          }}>
          <AddCircleOutline /> <span className={classes.menuLabel}>Add pro to plan</span>
        </Button>
        <Button
          classes={{
            root: classes.shipmentSelectionActionButton,
            disabled: classes.disabledButton
          }}
          disabled={!hasAdminOrManagerAccess()}
          onClick={() =>
            hasAdminOrManagerAccess() ? onAddUpdateProToPlanClick(PRO_MODE.update) : null
          }>
          <EditIcon /> <span className={classes.menuLabel}>Update pro status</span>
        </Button>
        <Button
          classes={{
            root: classes.shipmentSelectionActionButton,
            disabled: classes.disabledButton
          }}
          disabled={!configJSON.enableShipmentForecast}
          onClick={goToShipmentForecast}>
          <InsertChartOutlined /> <span className={classes.menuLabel}>Shipment Forecast</span>
        </Button>
      </div>
    </Menu>
  );
};

export default compose(withUserProfile, withStyles(styles))(ShipmentSelectionMenu);
